import React from 'react'
import"./ContactPhase2.css"
const ContactPhase2 = () => {
  return (
    <div className='phase1box'>
        <h1 className="phase1head"style={{ textAlign: "center" }}>Let's take your business to the next level.</h1>
        <p className="phase1para"style={{ textAlign: "center" }}></p>
    </div>
  )
}

export default ContactPhase2